<template>
  <div class="download-popup">
    <div class="header">
      <div class="header__images">
        <van-image :src="downloadPopupLogoUrl" />
      </div>
      <div class="header__label">
        <span>Por favor, faça um atalho.</span>
      </div>
    </div>

    <div class="buttons-container">
      <div class="main-button" @click="emit('install')">Atalho da área de trabalho</div>
    </div>
  </div>
</template>

<script setup>
import { downloadPopupLogoUrl } from './js/index.js'

const emit = defineEmits(['install'])
</script>

<style lang="less" scoped src="./css/index.less"></style>
